import { render } from "./PublicToolDemoApp.vue?vue&type=template&id=b2b92eb6"
import script from "./PublicToolDemoApp.vue?vue&type=script&lang=js"
export * from "./PublicToolDemoApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__